// Fire the global upgrade / buy-credits modal. `detail` is the backend 402 paywall body
// ({ message, action, needed, have }) plus an optional human `feature` label.
export function showPaywall(detail) {
  window.dispatchEvent(new CustomEvent("rp-paywall", { detail: detail || {} }));
}
